import { defineComponent } from 'vue';
import Header from '@/components/Header.vue';
export default defineComponent({
  components: {
    Header
  },
  watch: {
    $route() {
      const refscroll = this.$refs.scroll;
      if (refscroll) refscroll.$el.scrollTop = 0;
    }
  },
  setup() {
    return {};
  }
});